import React, { useState } from "react";
import Switch from "@mui/material/Switch";
import { FormControl, FormLabel } from "@mui/material";
import { setIsAlbum } from "../../redux/slices/contentSlice/contentForm/contentForm";
import { useDispatch, useSelector } from "react-redux";

const IsAlbum = ({ label }) => {
  const dispatch = useDispatch();
  const isAlbum = useSelector((state) => state.contentForm.isAlbum);
  const handleChange = () => {
    dispatch(setIsAlbum(!isAlbum));
  };
  return (
    <FormControl>
      <FormLabel component="legend">{label}</FormLabel>
      <Switch
        checked={isAlbum}
        onChange={handleChange}
        inputProps={{ "aria-label": "Is Album" }}
      />
    </FormControl>
  );
};

export default IsAlbum;
